import { render, staticRenderFns } from "./SupportFileList.vue?vue&type=template&id=4d56c8bf&"
import script from "./SupportFileList.vue?vue&type=script&lang=ts&"
export * from "./SupportFileList.vue?vue&type=script&lang=ts&"
import style0 from "./SupportFileList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports